import type { GraphQLTypes, InputType } from '@zeus/index'
import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const answerFields = { answeredAt: true, needs: true, ratings: { objective: true, level: true } } as const
const sessionPositioningFields = { sessionId: true, sessionName: true, entry: answerFields, exit: answerFields } as const

/** Positionnement d'entrée et de sortie d'un apprenant (#321), pour sa fiche. */
export const GQL_LEARNER_POSITIONING = typedGql('query', { scalars })({
  learnerPositioning: [{ userId: $('userId', 'ID!') }, sessionPositioningFields],
})

/** L'apprenant se positionne sur un parcours (#321). */
export const GQL_SUBMIT_POSITIONING = typedGql('mutation', { scalars })({
  submitPositioning: [{ input: $('input', 'SubmitPositioningInput!') }, true],
})

export type SessionPositioning = InputType<GraphQLTypes['SessionPositioningModel'], typeof sessionPositioningFields, typeof scalars>
